export const GET_MEDIA_FILE_SUCCEEDED = "GET_MEDIA_FILE_SUCCEEDED";
export const GET_MEDIA_FILE_REQUESTED = "GET_MEDIA_FILE_REQUESTED";
export const GET_MEDIA_FILE_FAILED = "GET_MEDIA_FILE_FAILED";
export const UPDATE_MEDIA_FILE_SUCCEEDED = "UPDATE_MEDIA_FILE_SUCCEEDED";
export const UPDATE_MEDIA_FILE_REQUESTED = "UPDATE_MEDIA_FILE_REQUESTED";
export const UPDATE_MEDIA_FILE_FAILED = "UPDATE_MEDIA_FILE_FAILED";
export const DELETE_CAMERA_DETAIL_SUCCEEDED = "DELETE_CAMERA_DETAIL_SUCCEEDED";
export const DELETE_CAMERA_DETAIL_REQUESTED = "DELETE_CAMERA_DETAIL_REQUESTED";
export const DELETE_CAMERA_DETAIL_FAILED = "DELETE_CAMERA_DETAIL_FAILED";
